import React from "react";

export const GoogleStoreBrandMedium = () => {
  return (
    <svg
      width="135"
      height="40"
      viewBox="0 0 135 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="134" height="39" rx="4.5" fill="black" />
      <path
        d="M68.137 21.7511C65.785 21.7511 63.868 23.5401 63.868 26.0041C63.868 28.4531 65.785 30.2571 68.137 30.2571C70.49 30.2571 72.407 28.4531 72.407 26.0041C72.406 23.5401 70.489 21.7511 68.137 21.7511ZM68.137 28.5831C66.848 28.5831 65.737 27.5201 65.737 26.0051C65.737 24.4741 66.849 23.4271 68.137 23.4271C69.426 23.4271 70.537 24.4741 70.537 26.0051C70.537 27.5191 69.426 28.5831 68.137 28.5831ZM58.823 21.7511C56.471 21.7511 54.554 23.5401 54.554 26.0041C54.554 28.4531 56.471 30.2571 58.823 30.2571C61.176 30.2571 63.093 28.4531 63.093 26.0041C63.093 23.5401 61.176 21.7511 58.823 21.7511ZM58.823 28.5831C57.534 28.5831 56.423 27.5201 56.423 26.0051C56.423 24.4741 57.535 23.4271 58.823 23.4271C60.112 23.4271 61.223 24.4741 61.223 26.0051C61.224 27.5191 60.112 28.5831 58.823 28.5831ZM47.745 23.0571V24.8611H52.063C51.934 25.8761 51.596 26.6171 51.08 27.1321C50.452 27.7601 49.469 28.4531 47.745 28.4531C45.087 28.4531 43.009 26.3101 43.009 23.6521C43.009 20.9941 45.087 18.8511 47.745 18.8511C49.179 18.8511 50.226 19.4151 50.999 20.1401L52.272 18.8671C51.192 17.8361 49.759 17.0471 47.745 17.0471C44.104 17.0471 41.043 20.0111 41.043 23.6521C41.043 27.2931 44.104 30.2571 47.745 30.2571C49.71 30.2571 51.193 29.6121 52.352 28.4041C53.544 27.2121 53.915 25.5361 53.915 24.1831C53.915 23.7651 53.883 23.3781 53.818 23.0561H47.745V23.0571ZM93.053 24.4581C92.699 23.5081 91.619 21.7511 89.412 21.7511C87.221 21.7511 85.4 23.4751 85.4 26.0041C85.4 28.3881 87.205 30.2571 89.621 30.2571C91.57 30.2571 92.698 29.0651 93.166 28.3721L91.716 27.4051C91.233 28.1141 90.572 28.5811 89.621 28.5811C88.671 28.5811 87.994 28.1461 87.559 27.2921L93.246 24.9401L93.053 24.4581ZM87.253 25.8761C87.205 24.2321 88.526 23.3951 89.477 23.3951C90.218 23.3951 90.846 23.7661 91.056 24.2971L87.253 25.8761ZM82.63 30.0001H84.498V17.4991H82.63V30.0001ZM79.568 22.7021H79.504C79.085 22.2021 78.279 21.7511 77.265 21.7511C75.138 21.7511 73.189 23.6201 73.189 26.0211C73.189 28.4051 75.138 30.2581 77.265 30.2581C78.28 30.2581 79.085 29.8071 79.504 29.2921H79.568V29.9041C79.568 31.5311 78.698 32.4011 77.297 32.4011C76.153 32.4011 75.444 31.5801 75.154 30.8871L73.527 31.5641C73.994 32.6911 75.234 34.0771 77.297 34.0771C79.488 34.0771 81.341 32.7881 81.341 29.6461V22.0101H79.569V22.7021H79.568ZM77.426 28.5831C76.137 28.5831 75.058 27.5031 75.058 26.0211C75.058 24.5221 76.137 23.4271 77.426 23.4271C78.698 23.4271 79.697 24.5221 79.697 26.0211C79.697 27.5031 78.698 28.5831 77.426 28.5831ZM101.807 17.4991H97.336V30.0001H99.201V25.2641H101.806C103.874 25.2641 105.908 23.7671 105.908 21.3821C105.908 18.9971 103.875 17.4991 101.807 17.4991ZM101.855 23.5241H99.201V19.2391H101.855C103.25 19.2391 104.042 20.3941 104.042 21.3821C104.042 22.3501 103.25 23.5241 101.855 23.5241ZM113.387 21.7291C112.036 21.7291 110.637 22.3241 110.058 23.6431L111.714 24.3341C112.068 23.6431 112.728 23.4171 113.419 23.4171C114.384 23.4171 115.365 23.9961 115.381 25.0251V25.1541C115.043 24.9611 114.319 24.6721 113.435 24.6721C111.65 24.6721 109.832 25.6531 109.832 27.4861C109.832 29.1591 111.296 30.2361 112.936 30.2361C114.19 30.2361 114.882 29.6731 115.316 29.0131H115.38V29.9781H117.182V25.1851C117.183 22.9671 115.525 21.7291 113.387 21.7291ZM113.161 28.5801C112.551 28.5801 111.698 28.2741 111.698 27.5181C111.698 26.5531 112.76 26.1831 113.677 26.1831C114.496 26.1831 114.883 26.3601 115.381 26.6011C115.236 27.7601 114.239 28.5801 113.161 28.5801ZM123.744 22.0021L121.605 27.4221H121.541L119.321 22.0021H117.311L120.64 29.5771L118.742 33.7911H120.688L125.819 22.0021H123.744ZM106.938 30.0001H108.803V17.4991H106.938V30.0001Z"
        fill="white"
      />
      <path
        d="M47.4176 10.2429C47.4176 11.0809 47.1696 11.7479 46.6726 12.2459C46.1086 12.8379 45.3726 13.1339 44.4686 13.1339C43.6026 13.1339 42.8656 12.8339 42.2606 12.2339C41.6546 11.6329 41.3516 10.8889 41.3516 10.0009C41.3516 9.11194 41.6546 8.36794 42.2606 7.76794C42.8656 7.16694 43.6026 6.86694 44.4686 6.86694C44.8986 6.86694 45.3096 6.95094 45.6996 7.11794C46.0906 7.28594 46.4036 7.50894 46.6376 7.78794L46.1106 8.31594C45.7136 7.84094 45.1666 7.60394 44.4676 7.60394C43.8356 7.60394 43.2896 7.82594 42.8286 8.26994C42.3676 8.71394 42.1376 9.29094 42.1376 9.99994C42.1376 10.7089 42.3676 11.2859 42.8286 11.7299C43.2896 12.1739 43.8356 12.3959 44.4676 12.3959C45.1376 12.3959 45.6966 12.1729 46.1436 11.7259C46.4336 11.4349 46.6016 11.0299 46.6466 10.5109H44.4676V9.78994H47.3746C47.4046 9.94694 47.4176 10.0979 47.4176 10.2429Z"
        fill="white"
      />
      <path
        d="M52.0277 7.737H49.2957V9.639H51.7597V10.36H49.2957V12.262H52.0277V13H48.5247V7H52.0277V7.737Z"
        fill="white"
      />
      <path
        d="M55.2785 13H54.5075V7.737H52.8315V7H56.9545V7.737H55.2785V13Z"
        fill="white"
      />
      <path d="M59.9375 13V7H60.7085V13H59.9375Z" fill="white" />
      <path
        d="M64.1277 13H63.3567V7.737H61.6807V7H65.8037V7.737H64.1277V13Z"
        fill="white"
      />
      <path
        d="M73.6084 12.225C73.0184 12.831 72.2854 13.134 71.4084 13.134C70.5314 13.134 69.7984 12.831 69.2094 12.225C68.6194 11.619 68.3254 10.877 68.3254 9.99999C68.3254 9.12299 68.6194 8.38099 69.2094 7.77499C69.7984 7.16899 70.5314 6.86499 71.4084 6.86499C72.2804 6.86499 73.0124 7.16999 73.6044 7.77899C74.1964 8.38799 74.4924 9.12799 74.4924 9.99999C74.4924 10.877 74.1974 11.619 73.6084 12.225ZM69.7784 11.722C70.2224 12.172 70.7654 12.396 71.4084 12.396C72.0514 12.396 72.5954 12.171 73.0384 11.722C73.4824 11.272 73.7054 10.698 73.7054 9.99999C73.7054 9.30199 73.4824 8.72799 73.0384 8.27799C72.5954 7.82799 72.0514 7.60399 71.4084 7.60399C70.7654 7.60399 70.2224 7.82899 69.7784 8.27799C69.3354 8.72799 69.1124 9.30199 69.1124 9.99999C69.1124 10.698 69.3354 11.272 69.7784 11.722Z"
        fill="white"
      />
      <path
        d="M75.5745 13V7H76.5125L79.4285 11.667H79.4615L79.4285 10.511V7H80.1995V13H79.3945L76.3435 8.106H76.3105L76.3435 9.262V13H75.5745Z"
        fill="white"
      />
      <path
        d="M47.4176 10.2429C47.4176 11.0809 47.1696 11.7479 46.6726 12.2459C46.1086 12.8379 45.3726 13.1339 44.4686 13.1339C43.6026 13.1339 42.8656 12.8339 42.2606 12.2339C41.6546 11.6329 41.3516 10.8889 41.3516 10.0009C41.3516 9.11194 41.6546 8.36794 42.2606 7.76794C42.8656 7.16694 43.6026 6.86694 44.4686 6.86694C44.8986 6.86694 45.3096 6.95094 45.6996 7.11794C46.0906 7.28594 46.4036 7.50894 46.6376 7.78794L46.1106 8.31594C45.7136 7.84094 45.1666 7.60394 44.4676 7.60394C43.8356 7.60394 43.2896 7.82594 42.8286 8.26994C42.3676 8.71394 42.1376 9.29094 42.1376 9.99994C42.1376 10.7089 42.3676 11.2859 42.8286 11.7299C43.2896 12.1739 43.8356 12.3959 44.4676 12.3959C45.1376 12.3959 45.6966 12.1729 46.1436 11.7259C46.4336 11.4349 46.6016 11.0299 46.6466 10.5109H44.4676V9.78994H47.3746C47.4046 9.94694 47.4176 10.0979 47.4176 10.2429Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M52.0277 7.737H49.2957V9.639H51.7597V10.36H49.2957V12.262H52.0277V13H48.5247V7H52.0277V7.737Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M55.2785 13H54.5075V7.737H52.8315V7H56.9545V7.737H55.2785V13Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M59.9375 13V7H60.7085V13H59.9375Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M64.1277 13H63.3567V7.737H61.6807V7H65.8037V7.737H64.1277V13Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M73.6084 12.225C73.0184 12.831 72.2854 13.134 71.4084 13.134C70.5314 13.134 69.7984 12.831 69.2094 12.225C68.6194 11.619 68.3254 10.877 68.3254 9.99999C68.3254 9.12299 68.6194 8.38099 69.2094 7.77499C69.7984 7.16899 70.5314 6.86499 71.4084 6.86499C72.2804 6.86499 73.0124 7.16999 73.6044 7.77899C74.1964 8.38799 74.4924 9.12799 74.4924 9.99999C74.4924 10.877 74.1974 11.619 73.6084 12.225ZM69.7784 11.722C70.2224 12.172 70.7654 12.396 71.4084 12.396C72.0514 12.396 72.5954 12.171 73.0384 11.722C73.4824 11.272 73.7054 10.698 73.7054 9.99999C73.7054 9.30199 73.4824 8.72799 73.0384 8.27799C72.5954 7.82799 72.0514 7.60399 71.4084 7.60399C70.7654 7.60399 70.2224 7.82899 69.7784 8.27799C69.3354 8.72799 69.1124 9.30199 69.1124 9.99999C69.1124 10.698 69.3354 11.272 69.7784 11.722Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M75.5745 13V7H76.5125L79.4285 11.667H79.4615L79.4285 10.511V7H80.1995V13H79.3945L76.3435 8.106H76.3105L76.3435 9.262V13H75.5745Z"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <g filter="url(#filter0_ii_2136_36895)">
        <path
          d="M10.4357 7.53784C10.1447 7.84584 9.97266 8.32384 9.97266 8.94284V31.0588C9.97266 31.6788 10.1447 32.1558 10.4357 32.4638L10.5097 32.5358L22.8987 20.1468V20.0008V19.8548L10.5097 7.46484L10.4357 7.53784Z"
          fill="url(#paint0_linear_2136_36895)"
        />
        <path
          d="M27.0274 24.2779L22.8984 20.1469V20.0009V19.8549L27.0284 15.7249L27.1214 15.7779L32.0144 18.5579C33.4114 19.3519 33.4114 20.6509 32.0144 21.4459L27.1214 24.2259L27.0274 24.2779Z"
          fill="url(#paint1_linear_2136_36895)"
        />
        <g filter="url(#filter1_i_2136_36895)">
          <path
            d="M27.1235 24.225L22.8995 20.001L10.4375 32.464C10.8975 32.952 11.6585 33.012 12.5155 32.526L27.1235 24.225Z"
            fill="url(#paint2_linear_2136_36895)"
          />
        </g>
        <path
          d="M27.1235 15.7769L12.5155 7.47694C11.6585 6.98994 10.8975 7.05094 10.4375 7.53894L22.9005 20.0019L27.1235 15.7769Z"
          fill="url(#paint3_linear_2136_36895)"
        />
      </g>
      <rect x="0.5" y="0.5" width="134" height="39" rx="4.5" stroke="#A6A6A6" />
      <defs>
        <filter
          id="filter0_ii_2136_36895"
          x="9.97266"
          y="7.14087"
          width="23.0898"
          height="25.7207"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2136_36895"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_2136_36895"
            result="effect2_innerShadow_2136_36895"
          />
        </filter>
        <filter
          id="filter1_i_2136_36895"
          x="10.4375"
          y="20.001"
          width="16.6875"
          height="12.8606"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2136_36895"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2136_36895"
          x1="21.8005"
          y1="8.70884"
          x2="5.01846"
          y2="25.4908"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2136_36895"
          x1="33.8329"
          y1="20.0009"
          x2="9.63704"
          y2="20.0009"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2136_36895"
          x1="24.8296"
          y1="22.2949"
          x2="2.0711"
          y2="45.0534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2136_36895"
          x1="7.2989"
          y1="0.176745"
          x2="17.4612"
          y2="10.339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};
